import { Component, ViewEncapsulation, OnInit, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FnUiFieldMetaDataService } from 'foundation';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  encapsulation:ViewEncapsulation.None
})
export class LoginComponent implements OnInit, AfterViewInit {

  response = false;
	showButton = true;
	metaData: any;
	loginUser = {
		username: 'admin',
		password: 'ad@admin',
	};
	private formStatus = {
		VALID: 'VALID',
		INVALID: 'INVALID',
	};
	constructor(
		
		private metaDataSvcs: FnUiFieldMetaDataService,
		private service: LoginService
	) {
	}

	ngOnInit(): void {
		this.loadMetaData();
	}
	ngAfterViewInit(): void {
		this.service.getCLientData();
	}

	loadMetaData() {
		this.metaDataSvcs.setFieldMap({
			username: {
				isRequired: true,
				isEnableOnUI: true,
				labelIDArray: [
					'Entity_EOUser_Field_username_LBL',
					'Entity_EOUser_Field_username_HVR',
				],
				minLength: 5,
				isInitialized: true,
				isShowInfo: false,
				labelPosition: 'left',
				recalAccess: false,
				typeID: {
					iid: 'TEXT',
					isNumber: false,
					defaultTableWidth: 50,
					defaultEditWidth: 20,
				},
				applicablePK: 0,
				id: 'Entity_EOUser_Field_username',
				isDisabled: false,
				key: 'username',
				maxLength: 255,
				isDynDetailKey: false,
				hideLabel: false,
			},
			password: {
				isRequired: true,
				isEnableOnUI: true,
				labelIDArray: [
					'Entity_EOUser_Field_password_LBL',
					'Entity_EOUser_Field_password_HVR',
				],
				minLength: 3,
				isInitialized: true,
				isShowInfo: false,
				labelPosition: 'left',
				recalAccess: false,
				typeID: {
					iid: 'PASSWORD',
					isNumber: false,
					defaultTableWidth: 50,
					defaultEditWidth: 20,
				},
				applicablePK: 0,
				id: 'Entity_EOUser_Field_password',
				isDisabled: false,
				key: 'password',
				maxLength: 255,
				isDynDetailKey: false,
				hideLabel: false,
			},
		});
		this.metaData = this.metaDataSvcs.getFieldMap();
	}
	onSubmit(loginForm: NgForm) {
		
		if (loginForm.form.status === this.formStatus.VALID) {
			this.service.login(this.loginUser.username,this.loginUser.password);
		}
}
}
